import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-events="container"]'
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initAccordions()
    }

    function initAccordions() {


        jQuery(function ($) {
            const $btn = $('#load-more-events');
            const $container = $('#events-holder');

            if (!$btn.length || !$container.length) return;
            let currentPage = parseInt($btn.data('page')) || 1;
            const maxPages = parseInt($btn.data('max')) || 1;
            const postsPerPage = 6;
            let loading = false;

            $btn.on('click', function (e) {
                e.preventDefault();
                if (loading || currentPage >= maxPages) return;

                loading = true;
                $btn.text('Chargement...');

                $.ajax({
                url: site_data.ajax_url,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'maisonlibere_load_more_events',
                    nonce: site_data.nonce,
                    page: currentPage + 1,
                },
                success: function (res) {
                    if (res.success && res.data.html) {
                    $container.append(res.data.html);
                    currentPage++;
                    $btn.data('page', currentPage);
                    if (!res.data.has_more || currentPage >= maxPages) {
                        $btn.hide();
                    } else {
                        $btn.text('VOIR PLUS');
                    }
                    } else {
                    $btn.hide();
                    }
                },
                error: function (xhr, status, error) {
                    console.error('AJAX error:', status, error);
                    $btn.text('Erreur');
                },
                complete: function () {
                    loading = false;
                },
                });
            });
        });


    }

    return Object.freeze({
        init,
    })
}